import { isDomainZone } from '@common/utils/lang';
import themeBoxBet from './boxbet';
import themeEpicBoom from './epicBoom';
import themeFormula55 from './formula55';

const theme = isDomainZone('ua') ? themeEpicBoom : isDomainZone('boxbet') ? themeBoxBet : themeFormula55;

export default theme;
